import React, { useState, useEffect } from "react";
import { useSortableData } from "../common/Helpers";
import {connect, useSelector} from "react-redux";
import PersonMain from "./PersonMain";
import PersonDetails from "./PersonDetails";
import PersonRequest from "./PersonRequest";
import {selectPerson} from "../../actions/people";
import Person from "./Person";

// import status SVGs from iconComponents
// import time library


export function PeopleList(props) {

    return (
        <div className="page-card narrow">
            {props.people.map((person, index) => { 

                const cardClass = 
                    "person " + 
                    (person.card_open && "selected ") + 
                    ((props.currentTab === "by_request" ? "request " : "") + 
                    (props.currentTab === "by_project" ? "locked" : ""));
                const userId = person.user_id ? person.user_id : "r-" + person.id
                const userBoxId = `${person.first_name} ${person.last_name}-${userId}`

                return ( 
                    <div id={userBoxId} className={cardClass} key={userId} >
                        <>
                            <Person 
                                person={person} 
                                currentTab={props.currentTab}
                                open={person.card_open}
                                userBoxId={userBoxId}
                            />
                        </>
                    </div>
                )   
            })}
        </div>
    )
}

const mapState = (state) => ({
    //auth: state.auth
});

export default connect(mapState, {selectPerson})(PeopleList);

